export default "__VITE_ASSET__BKhTC7zk__"